import script from "./VendorAppontmentDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorAppontmentDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./VendorAppontmentDetailPage.vue?vue&type=style&index=0&id=05dd6c66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05dd6c66"]])

export default __exports__